import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMediaQuery } from '@mui/material';

const ScrollToTopOnMobile = () => {
  const { pathname } = useLocation();
  const isMobile = useMediaQuery('(max-width:600px)');

  useEffect(() => {
    if (isMobile) {
      window.scrollTo(0, 0);
    }
  }, [pathname, isMobile]);

  return null; // This component renders nothing
};

export default ScrollToTopOnMobile;